<template>
  <div class="pro-work-item clearfix answer-item">
    <div  v-for="items in answerData" :key="items.id">
      <div class="user-avatar">
        <router-link :to="{ path: '/home', query: { userId: items.userId } }" class="avatar-f">
          <img :src="`http://iss.21teacher.com/avatar/125/${items.userId}/20.jpg`" alt="">
        </router-link>
      </div>
      <div class="item-infoes">
        <div class="user-name-title clearfix">
          <router-link :to="{ path: '/home', query: { userId: items.userId } }"  class="name">{{items.userName}}</router-link>
          <el-button class="set-best-btn" v-if="queAcceptId == 0 && loginUserId == queUserId " v-on:click="setA(items.id,items.answerto)">评为最佳</el-button>
          <el-button class="set-best-btn" type="primary" v-if="items.praise == 1 ">最佳答案</el-button>
<!--          <span class="show-date">{{items.publishDate | formatTime}}</span>-->
        </div>
        <overflow-words :words="items.content" />
<!--        <icons-talk class="icons-talk"></icons-talk>-->
        <talkPart
                :objType="9"
                :objId="items.id"
                v-if="isReload"
                :key="items.id"
                :isDT="false"
                :loadShow="false"></talkPart>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import overflowWords from './overflow'
import iconsTalk from './iconsTalk'
import answerApi from "@/api/answer";
import questionApi from "@/api/question";
import talkPart from '@@/pub/talkpart/talkpart'
export default {
  components: {
    overflowWords,
    talkPart
  },
  props: ['answerData','queAcceptId','queUserId'],
  data () {
    return {
      isReload:true,
      loginUserId :0,
      praiseForm:{
        id:0,
        accept:1,			//是否采纳		(0为否；1为是；)
        praise:1,		//是否最佳		(0为否；1为是；)
        answerto:0,
      },
      acceptForm:{
        id:0,
        accept:0,			//采纳ID
      },
    }
  },
  mounted () {
    if(this.global.isLogin){
      this.loginUserId = this.global.userModel.id
    }

  },
  methods: {
    setA(id,answerto){
      let thiss = this
      thiss.praiseForm.id = id
      thiss.praiseForm.answerto = answerto

      thiss.acceptForm.id = answerto
      thiss.acceptForm.accept = id
      answerApi.update(thiss.praiseForm).then( re =>{
        if(re.code == 1){

          questionApi.update(thiss.acceptForm).then(reB =>{
            thiss.$parent.questionObj.accept = id
            thiss.$parent.$parent.getAcceptUser();
            setTimeout(()=>{
              thiss.$parent.getAnswer()
            },1000)

          })

        }else{
          thiss.$message.error("评选失败")
        }
      })

    },

  }
}
</script>

<style scoped lang="less">
.pro-work-item{
  padding-top: 15px;
  .set-best-btn{
    margin-top: 10px;
    margin-left: 5px;
    width: 90px;
    height: 30px;
  }
  .show-date{
    margin-top: 10px;
    margin-left: 10px;
    line-height: 30px;
    font-size: 12px;
  }
  .icons-talk{
    margin-top: 10px;
  }
}
</style>
